import { useTranslation } from "react-i18next";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getFiltersClaims } from "../api/getFilters";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";

type QueryFnType = typeof getFiltersClaims;
type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useFiltersClaims = (config?: UseFiltersOptions) => {
    const { t } = useTranslation(["dashboard"]);
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["filtersClaim", i18n.language],
        queryFn: async () => {
            const filters = await getFiltersClaims(t);

            // translate here
            return filters;
        }
    });
};